import { put, takeLatest, fork } from 'redux-saga/effects'
import values from 'lodash/values'
import { ActionType, IStorageImageCallback } from './model'
import { ActionCallback, IAxiosResponse } from '../model'
import { createApiCall } from 'services/api'

export function* changeLangSaga(): Generator {
  yield takeLatest(ActionType.CHANGE_LANG, function* (action: any) {
    try {
      yield put({ type: ActionType.SET_LANG, payload: action.payload.lang })
    } catch (error) {
      // error
    }
  })
}

export function* postImageSaga(): Generator {
  yield takeLatest(ActionType.POST_IMAGE, function* (action: ActionCallback<any, IStorageImageCallback>) {
    try {
      const { payload, callback } = action
      const { data, status }: IAxiosResponse = yield createApiCall({
        method: 'POST',
        url: '/company-logo',
        data: payload,
      })

      if (status === 200) {
        callback(data)
      } else if (status >= 400 && status < 500) {
        callback({
          error: values(data.fields)[0],
        })
      }
    } catch (error) {
      // error
    }
  })
}

export default [fork(changeLangSaga), fork(postImageSaga)]
